import { Component } from '@angular/core';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { FormGroup } from '@angular/forms';
import { take } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { FaqService } from '../crud-service';
import { FaqCrudIndex } from './crud-index';
import { filterFields } from '../crud-config';
import { FilterFaqDialogComponent } from '../filter-faq-dialog/filter-faq-dialog.component';

@Component({
  selector: 'app-events-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [FaqService],
})
export class FaqIndexComponent extends FaqCrudIndex {
  override ngOnInit(): void {}
  override filterFields: IFieldConfig[] = filterFields;

  override submitAdvancedFilter(filterForm: FormGroup) {
    let _filterForm = this.getFilters(filterForm.value);
    this.service
      .findByFilter(_filterForm, this.params)
      .pipe(take(1))
      .subscribe((dataWithPagination: any) => {
        let data = dataWithPagination[0];
        this.length = dataWithPagination[1];

        this.dataSource = new MatTableDataSource<any>(
          data.map((item: any) => {
            return item;
          })
        );
      });
  }

  override ngAfterViewInit(): void {
    this.abrirFiltroModal();
  }

  private getFilters(filter: any) {
    if (!filter) return {}
    let params: any = {}
    if (filter.name) params.name = filter.name.toUpperCase()
    if (filter.description) params.description = filter.description.trim()
    if (filter.typeEvent && filter.typeEvent !== 'TODOS') params.typeEvent = filter.typeEvent
    if (filter.typeQuestion && filter.typeQuestion !== 'TODOS') params.typeQuestion = filter.typeQuestion
    return params
  }
  
  abrirFiltroModal(): void {
    this.dialog
      .open(FilterFaqDialogComponent, {
        width: '400px',
        data: {
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result && Object.keys(result).length > 0) {
          this.submitAdvancedFilter(result);
        } else {
          this.params.filter = '';
          this.loadList();
        }
      });
  }
}
